import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { RealCostMultiplier } from "../../models/real-cost.model";
import { RealCostRepository } from "../../repositories/real-cost.repository";

interface SaveMultipliersUseCaseParams {
  contractId: number;
  multipliers: RealCostMultiplier[] | null;
  straight40?: boolean | null;
}

export class SaveMultipliersUseCase
  implements UseCase<SaveMultipliersUseCaseParams, void>
{
  constructor(private repo: RealCostRepository) {}
  execute(param: SaveMultipliersUseCaseParams): Observable<void> {
    return this.repo.saveMultipliers(param.contractId, param.multipliers, param.straight40);
  }
}

const saveMultipliersUseCaseFactory = (repo: RealCostRepository) =>
  new SaveMultipliersUseCase(repo);

export const saveMultipliersUseCaseProvider: Provider = {
  provide: SaveMultipliersUseCase,
  useFactory: saveMultipliersUseCaseFactory,
  deps: [RealCostRepository],
};
